import { render } from "./SmaPriSendButton.vue?vue&type=template&id=c590177c"
import script from "./SmaPriSendButton.vue?vue&type=script&lang=ts"
export * from "./SmaPriSendButton.vue?vue&type=script&lang=ts"
script.render = render

export default script